import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-bs-placement", "title"];
const _hoisted_2 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", null, [
        (!_ctx.testMode)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onMouseover: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.loadTip && _ctx.loadTip(...args))),
                onMouseleave: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.hideTip && _ctx.hideTip(...args))),
                "data-bs-toggle": "tooltip",
                "data-bs-placement": _ctx.placement,
                title: _ctx.tip,
                ref: "tooltip",
                style: { "margin": "0", "padding": "0" }
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 40, _hoisted_1))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _renderSlot(_ctx.$slots, "default")
            ]))
    ]));
}
